"use client";
import type { ReactNode } from "react";
import { useFormStatus } from "react-dom";

/** A submit button that goes inert (still focusable) while its form's action is pending, so a double-tap can't submit twice. */
export function SubmitButton({ className, children }: { className?: string; children: ReactNode }) {
  const { pending } = useFormStatus();
  return (
    <button type="submit" className={className} aria-disabled={pending ? true : undefined} aria-busy={pending ? true : undefined}
      onClick={(e) => { if (pending) e.preventDefault(); }}>
      {children}
    </button>
  );
}
